<template>
    <div class="d-inline-block">
        Stránky vytvořili <a href="//softici.cz">Softíci.cz</a> <img class="badge-logo"
                                                                     src="/images/softici_badge_lg.png">
    </div>
</template>

<script>
export default {
    name: 'softici-badge',
}
</script>

<style lang="scss" scoped>
.badge-logo {
    width:    25px;
    position: relative;
    bottom:   8px;
}

a {
    font-weight: bold;
    color:       #018374;
}
</style>
